import styled from 'styled-components';

export const TagsListWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  margin: 2rem;
  z-index: 5;
`;
